import { type CallEffect, call } from 'redux-saga/effects';

import { handleSkippingAd, log } from './helpers';
import { type ISkipAdAction } from './types';

export function* skipAd(action: ISkipAdAction): Generator<CallEffect<void>> {
  log.info('skipAd(): starting skip ad');
  yield call(handleSkippingAd, action);
}
